<template>
  <div>
    <div class="title">訂購須知</div>
    <div class="info">1.目前付款方式僅接受銀行匯款。</div>
    <div class="info">2.冷藏食品請立即儲存於冰箱中，並保持適當的低溫以確保品質。</div>
    <div class="info">3.冷藏商品除配送錯誤、商品本身有瑕疵或運送過程失溫導致變質外，將不另提供退換貨退款服務。</div>
    <div class="info">5.商品規格</div>
    <div class="info">6.訂購後約3~5個工作天出貨。</div>
  </div>
</template>

<script>
export default {
  name: "OrderInfo"
}
</script>

<style scoped>
.title{
  font-family: Noto Sans TC;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333;
}
.info{
  font-family: Noto Sans TC;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-align: left;
  color: #333;
}

</style>
